import { Box } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { useReactToPrint } from "react-to-print";
import { useCallback, useEffect, useRef, useState } from "react";
import ManufacturingLabelPrint from "../../../../../pages/Manufacturer/ManufacturingLabelPrint ";

const DownloadManufacturePrint = ({qrCodeDataUrl,patientData, patientMedicalInfo,patientInfo}) =>{
  const [printData, setPrintData] = useState(null);
  const printTimeoutAllRef = useRef(null);
  const printContentAllRef = useRef(null);
    const reactToPrintFnAll = useReactToPrint({
    content: () => printContentAllRef.current,
    });

  useEffect(() =>{   
      const result = {
        printPatientInfo:patientData,
        qrCodeDataUrl,
        bagCount:patientInfo?.bagCount,
        printCount: 1,
        printSingleBag: null,
        patientMedicalInfo
      };
      setPrintData(result);
    }, [patientData,patientMedicalInfo,qrCodeDataUrl])
 
      const handleFullPrint = useCallback(() => {
    
      printTimeoutAllRef.current = setTimeout(() => {
        reactToPrintFnAll();
        printTimeoutAllRef.current = null;
      }, 100);
    }, [reactToPrintFnAll, patientData]);

    return (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <LoadingButton
                    type="button"
                    size="small"
                    onClick={handleFullPrint}
                    className="!w-[100px] "
                  >
                    Print
                  </LoadingButton>
                </Box>
                {printData && (<div className="mx-auto flex justify-center">
                     <ManufacturingLabelPrint
                                ref={printContentAllRef}
                                printData={printData}
                                isVisible={true}
                              />
                  </div>)}
                </>
      );
}
export default DownloadManufacturePrint